import styled from 'styled-components';

export const Container = styled.div`
  
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #D3D3D3;

  h2 {
    font-family: 'Poppins';
    font-size: 22px;
    font-weight: 400;
  }

  p {
    font-family: 'Poppins';
    font-size: 14px;
    font-weight: 400;
  }
`;



export const Form = styled.form`
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 8px;
  background: #fff;
  .fieldset {
    padding: 10px 4px;
    border: none;
    /* border-top: 1px solid #D3D3D3; */
  }

  .fieldset:not(:last-child) {
    
    border-bottom: 2px dashed #d3d3d3;
  }
  .input-group {
    display: flex;
    align-items: center;
    gap: 10px;
    /* margin-bottom: 10px; */
    padding: 10px 0;
    /* width: 100%; */
  }

  .input-wrapper {
    width: 100%;
    .input {
        width: 100%;
        background: #fff;
    }
  }
`;

